import { categories } from "@/mocks/categories";
import { Link } from "react-router-dom";

export default function ContentSection() {
  return (
    <section className="bg-background-50 py-12 md:py-20">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-3xl mx-auto">
          <p className="text-xs font-semibold text-foreground-500 uppercase tracking-[0.2em] mb-3">
            About Our Spreadsheet
          </p>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-6 leading-tight">
            Die größte OOPBUY Spreadsheet — Dein ultimativer Guide für Smart Shopping
          </h2>

          <div className="prose prose-sm md:prose-base max-w-none text-foreground-700 space-y-4 leading-relaxed">
            <p>
              Du suchst nach der <strong>besten OOPBUY Spreadsheet</strong>? Du hast sie gefunden.
              Unsere kuratierte <strong>OOPBUY Spreadsheet 2026</strong> umfasst über 3.000
              hochwertige Produkte von verifizierten OOPBUY-Verkäufern, sortiert in
              übersichtliche Kategorien wie Schuhe, Kleidung, Taschen, Accessoires und mehr.
              Egal, ob du ein Erstkäufer bist oder bereits Erfahrung hast — hier findest du
              den umfassendsten OOPBUY Guide.
            </p>

            <p>
              Was macht unsere Spreadsheet zur <strong>größten OOPBUY Spreadsheet</strong>? Wir
              aktualisieren sie täglich mit den neuesten <strong>OOPBUY Finds</strong> und den
              besten Produkten auf OOPBUY. Unser Team prüft jeden Artikel, damit du nur
              <strong> hochwertige OOPBUY Finds</strong> von verifizierten und
              <strong> OOPBUY trusted sellers</strong> siehst. Kein endloses Scrollen durch
              unzuverlässige Links mehr — wir haben die Arbeit für dich erledigt.
            </p>

            <p>
              Entdecke unsere Guides:{" "}
              <Link to="/guide/oopbuy-spreadsheet-anfaenger" className="text-primary-600 hover:text-primary-700 underline">Anfänger-Guide</Link>
              {", "}
              <Link to="/guide/oopbuy-spreadsheet-versand" className="text-primary-600 hover:text-primary-700 underline">Versand Guide</Link>
              {", "}
              <Link to="/guide/oopbuy-spreadsheet-sneaker" className="text-primary-600 hover:text-primary-700 underline">Sneaker Guide</Link>
              {", "}
              <Link to="/guide/oopbuy-spreadsheet-qc" className="text-primary-600 hover:text-primary-700 underline">QC Guide</Link>.{" "}
              Oder stöbere direkt in den Kategorien:{" "}
              {categories.slice(0, 5).map((cat, i) => (
                <span key={cat.name}>
                  <a href={cat.url} target="_blank" rel="noopener nofollow" className="text-primary-600 hover:text-primary-700 underline">{cat.name}</a>
                  {i < 4 ? ", " : ""}
                </span>
              ))}{" "}
              und mehr.
            </p>

            <p>
              Möchtest du wissen, wie OOPBUY im Vergleich zu anderen Agenten abschneidet?
              Lies unsere detaillierten Vergleiche:{" "}
              <Link to="/guide/oopbuy-spreadsheet-vergleich" className="text-primary-600 hover:text-primary-700 underline">
                OOPBUY vs andere Agenten
              </Link>.
            </p>

            <p>
              Bereit, die besten Produkte bei OOPBUY zu finden?{" "}
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-primary-600 hover:text-primary-700 underline font-medium">
                Durchstöbere die OOPBUY Spreadsheet jetzt
              </a>{" "}
              und entdecke, warum tausende Käufer unsere kuratierte Auswahl täglich vertrauen.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}